import { apiCall } from "./api";

const URL = "/api/v1/service";

export const getServices = () => {
  return apiCall(URL, {
    method: "GET",
  });
};

export const updateService = (serviceId, data) => {
  return apiCall(`${URL}/${serviceId}`, {
    method: "PUT",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    credentials: "include",
    body: JSON.stringify(data),
  });
};
